import { Icon, type IconProps } from '@bos/ui';

export type AppBaseIconProps = IconProps;

/** Use AppIcon instead of AppBaseIcon, it should be used only within packages like mobility-ui */
export const AppBaseIcon = (props: AppBaseIconProps) => {
	return <Icon {...props} />;
};
